import { Reveal, PageHero, GoldBtn } from "@/components/Shared";
import Accordion from "@/components/Accordion";
import { FAQS } from "@/data/content";

export default function Faq() {
    return (
        <div data-testid="faq-page">
            <PageHero
                testid="faq-hero"
                eyebrow="Frequently Asked Questions"
                title={<>Everything About <span className="gold-text">the Bazaar</span></>}
                sub="The festival, the format, the participation paths — answered."
            />
            <section className="py-16 md:py-24">
                <div className="container-x max-w-4xl">
                    <Reveal>
                        <Accordion items={FAQS} testidPrefix="faq" />
                    </Reveal>
                    <Reveal className="mt-16 text-center">
                        <p className="text-sm text-muted-luxe mb-8">Still curious? The bazaar team is one message away.</p>
                        <GoldBtn to="/contact" testid="faq-contact-btn">Ask a Question</GoldBtn>
                    </Reveal>
                </div>
            </section>
        </div>
    );
}
